import request from '@/router/axios';
let urlPrefix = '/api/exp/expcourse';

/**
 * 获取列表
 * @param {页数} page
 * @param {每页条数} limit
 * @param {查询参数} params
 */
export const getList = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit,
        }
    });
};

/**
 * 获取标签列表
 */
export const selectCourseList = () => { return request(`${urlPrefix}/select`); };

/**
 * 单个删除
 * @param {Sring} id 记录ID
 */
export const remove = id => { return request(`${urlPrefix}/${id}`, {}, 'delete'); };

/**
 * 获取对象
 * @param {ID} id
 */
export const getEntity = id => {
    return request(`${urlPrefix}/${id}`);
};

/**
 * 添加操作
 * @param {对象} data
 */
export const add = data => {
    return request(urlPrefix, { data }, 'post');
};

/**
 * 编辑操作
 * @param {对象} data
 */
export const update = data => {
    return request(urlPrefix, { data }, 'put');
};

/**
 * 查重操作
 * @param {参数} params
 */
export const duplicateCheck = params => {
    return request(`${urlPrefix}/duplicateCheck`, { params });
};
